import { gql } from "@apollo/client";
export const InitiateOAuthFlow = gql `
  mutation InitiateOAuthFlow($input: InitiateOAuthFlowRequest!) {
    initiateOAuthFlow(input: $input) {
      authenticationUrl
      readOnlyAuthenticationUrl
      readAndWriteAuthenticationUrl
      provider
      authTokenOrAuthorizationCode
    }
  }
`;
export const RefreshExternalToken = gql `
  mutation RefreshExternalToken($input: RefreshExternalTokenRequest!) {
    refreshExternalToken(input: $input) {
      accessToken
      refreshToken
      expiresInSeconds
      refreshTokenExpiresInSeconds
    }
  }
`;
export const VerifyAccounts = gql `
  mutation VerifyAccounts($input: VerifyAccountsRequest!) {
    verifyAccounts(input: $input) {
      verifications {
        externalId
        platformId
        integrationName
        firstName
        middleName
        lastName
        email
        mobileNumber
        countryCode
        city
        postalCode
        dateOfBirth
      }
    }
  }
`;
